module.exports = __webpack_public_path__ + "img/code.295f9d34.png";